<template>
  <transition :name="transitionName" :mode="modeType">
    <slot/>
  </transition>
</template>

<script>
const DEFAULT_TRANSITION = 'fade';
const DEFAULT_TRANSITION_MODE = ''; // in-out or out-in

export default {
  name: 'TransitionPage',
  data() {
    return {
      transitionName: DEFAULT_TRANSITION,
      modeType: DEFAULT_TRANSITION_MODE
    }
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      // this.transitionName = to.meta.transitionName || from.meta.transitionName || DEFAULT_TRANSITION;
      this.transitionName = to.meta.transitionName || DEFAULT_TRANSITION;
      this.modeType = to.meta.modeType || DEFAULT_TRANSITION_MODE;
      next();
    });
  }
};
</script>

<style lang="scss" scoped>
  .fade-enter-active, 
  .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, 
  .fade-leave-active {
    opacity: 0
  }

  // FADE IN
  .fadeIn-enter-active, 
  .fadeIn-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fadeIn-enter-active {
    transition-delay: .25s;
  }

  .fadeIn-enter {
    opacity: 0
  }

  // SLIDE

  .slide-enter-active,
  .slide-leave-active {
    transition: all .5s;
    overflow: hidden;
  }

  .slide-enter {
    transform: translate(100%, 0);
    
  }

  .slide-leave-active {
    opacity: 0;
    transform: translate(-100%, 0);
  }
</style>
